import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const services =
    [
        {
            id: "01",
            links: "/capabilities/ai-automation",
            title: "AI Automation",
            desc: "The program eliminates operational complexity by extending the comprehensive protection of your public cloud resources.",
            img: "/assets/what/c1.png",
            bgColor: "bg-[#15377B]",
            span: "lg:col-span-2 lg:row-span-1"
        },
        {
            id: "02",
            links: "/capabilities/enterprise-applications",
            title: "Enterprise Applications",
            desc: "Robust end-to-end encryption and compliance-first strategies.",
            img: "/assets/what/c2.png",
            bgColor: "bg-[#162646]",
            span: "lg:col-span-1 lg:row-span-1"
        },
        {
            id: "03",
            links: "/capabilities/digital-workflows",
            title: "Digital Workflows",
            desc: "Transforming raw data into fascinating insights.",
            img: "/assets/what/c3.png",
            bgColor: "bg-[#5B6787]",
            span: "lg:col-span-1 lg:row-span-1"
        },
        {
            id: "04",
            links: "/capabilities/cloud-engineering",
            title: "Cloud Engineering",
            desc: "Building intuitive digital experiences.",
            img: "/assets/what/c4.png",
            bgColor: "bg-[#163166]",
            span: "lg:col-span-2 lg:row-span-1"
        },
        {
            id: "05",
            links: "/capabilities/industrial-engineering",
            title: "Industrial Engineering",
            desc: "Building intuitive digital experiences.",
            img: "/assets/what/c5.png",
            bgColor: "bg-[#5077C6]",
            span: "lg:col-span-2 lg:row-span-1"
        },
        {
            id: "06",
            links: "/capabilities/product-engineering",
            title: "Product Engineering",
            desc: "Transforming raw data into fascinating insights.",
            img: "/assets/what/c6.png",
            bgColor: "bg-[#3D5991]",
            span: "lg:col-span-1 lg:row-span-1"
        },
        {
            id: "07",
            links: "/capabilities/quality-engineering",
            title: "Quality Engineering",
            desc: "Transforming raw data into fascinating insights.",
            img: "/assets/what/c7.png",
            bgColor: "bg-[#15377B]",
            span: "lg:col-span-1 lg:row-span-1"
        },
        {
            id: "08",
            links: "/capabilities/managed-services",
            title: "Managed Services",
            desc: "Building intuitive digital experiences.",
            img: "/assets/what/img3.png",
            bgColor: "bg-[#5B6787]",
            span: "lg:col-span-2 lg:row-span-1"
        }
    ]

const ReinventServices = () => {
    return (
        <section className="w-full py-[40px] lg:py-[80px] bg-white font-sans">
            <div className="max-w-[1440px] mx-auto px-[20px] lg:px-[80px]">

                <h2 className="text-[#01386A] text-[20px] lg:text-[30px] font-[600] mb-[50px] font-sora">
                    The services to help you reinvent
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[23px]">
                    {services.map((service) => (
                        <motion.div
                            key={service.id}
                            className={`relative group cursor-pointer overflow-hidden min-h-[300px] lg:min-h-[300px] ${service.span} ${service.bgColor}`}
                        >
                            <motion.img
                                src={service.img}
                                alt={service.title}
                                className="absolute inset-0 w-full h-full object-cover opacity-0 group-hover:opacity-100 transition-all duration-700 scale-110 group-hover:scale-100"
                            />
                            <div className={`absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity duration-500`} />
                            <div className="relative z-10 p-10 h-full flex flex-col">
                                <motion.div
                                    className="transition-all duration-500 transform translate-y-[280px] group-hover:translate-y-0"
                                >
                                    <div className="flex flex-col">
                                        <h3 className="text-white font-sora text-[16px] lg:text-[20px] font-[600] leading-tight">
                                            {service.title}
                                        </h3>
                                    </div>
                                </motion.div>
                                <div className="mt-auto opacity-0 group-hover:opacity-100 transition-all duration-500 underline text-[#FFFFFF] translate-y-10 group-hover:translate-y-0">
                                    <Link to={service?.links}>
                                        <div className="flex items-center gap-2 text-[#FFFFFF] text-[14px] lg:text-[16px] font-[500] font-graphik tracking-wider">
                                            Read More
                                            <ArrowUpRight size={18} />
                                        </div>
                                    </Link>
                                </div>


                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section >
    );
};

export default ReinventServices;